<div class="wrap">
  <div *ngIf="filteredByClub" class="allClubs">
    Offres du club <b>{{clubSelected}}</b>
    <button appChangeColorTheme attribute="bgc" (click)="resetFilter()">
      <span class="textNoMobile">Etendre aux offres de tous les clubs</span>
      <span class="textMobile">
        <fa-icon [icon]="getFaIcon('faTimes')"></fa-icon>
        Filtre
      </span>
    </button>
  </div>


  <button appChangeColorTheme attribute="bgc" class="faQuestionCircle" (click)="openDialogHelp()">
    <fa-icon [icon]="getFaIcon('faQuestionCircle')"></fa-icon>
    Aide
  </button>

  <section>
    <div class="offers">
      <ngx-simplebar class="offers_filter" *ngIf="widthScreen > 768">
        <div class="section_universe">
          <h2>Votre univers</h2>

          <mat-radio-group [color]="color" aria-label="Select an option" class="univers_radio_button">
            <div class="label_radio_button">
              <mat-radio-button (click)="goToUniverseWithQueryParam(1)" [checked]="universIsSelected(1)" value="1">
                <span class="radioLabel">
                  Loisirs et Découvertes
                </span>
              </mat-radio-button>
            </div>

            <div class="label_radio_button">
              <mat-radio-button (click)="goToUniverseWithQueryParam(2)" [checked]="universIsSelected(2)" value="2">
                <span class="radioLabel">
                  Compétitions
                </span>
              </mat-radio-button>
            </div>

            <div class="label_radio_button">
              <mat-radio-button (click)="goToUniverseWithQueryParam(3)" [checked]="universIsSelected(3)" value="3">
                <span class="radioLabel">
                  Formations Professionnelles
                </span>
              </mat-radio-button>
            </div>

            <div class="label_radio_button">
              <mat-radio-button (click)="goToUniverseWithQueryParam(4)" [checked]="universIsSelected(4)" value="4">
                <span class="radioLabel">
                  Entreprises
                </span>
              </mat-radio-button>
            </div>

            <div class="label_radio_button">
              <mat-radio-button (click)="goToUniverseWithQueryParam(6)" [checked]="universIsSelected(6)" value="6">
                <span class="radioLabel">
                  Apprendre et se perfectionner
                </span>
              </mat-radio-button>
            </div>
          </mat-radio-group>
        </div>

        <div class="offers_filter_tags" *ngIf="tagsSelected?.length">

          <ng-container *ngFor="let t of tagsSelected">
            <span class="tag" (click)="removeTag(t)" [style.background-color]="getValueColorTag(t)">
              <fa-icon [icon]="getFaIcon('faTimesCircle')"></fa-icon>
              {{t.tagName}}
            </span>
          </ng-container>
        </div>
        <hr *ngIf="tagsSelected?.length">

        <div [ngClass]="{offers_filter_tags_reduce: !moreTag, offers_filter_tags_more: moreTag}" id="tags">
          <ng-container *ngFor="let t of tags">
            <span *ngIf="isInTagSelected(t?.tagName)" class="tag" (click)="addTag(t)"
              [style.background-color]="getValueColorTag(t)"> {{t.tagName}} </span>
          </ng-container>

          <div class="more_tags" *ngIf="!moreTag" (click)="moreTag = true">
            <span appChangeColorTheme attribute="bgc">Afficher plus</span>
          </div>
        </div>

        <div class="offers_filter_search">
          <form [formGroup]="searchForm">
            <input ngx-google-places-autocomplete (onAddressChange)="getAddressSearch($event)" type="text"
              formControlName="keyword" placeholder="Choix de la ville...">

          </form>
          <fa-icon [icon]="valueInput ? getFaIcon('faTimes') : getFaIcon('faSearch')"
            (click)="valueInput ? resetSearch(): null"></fa-icon>
        </div>

      </ngx-simplebar>

      <ngx-simplebar class="offers_content">

        <div class="load" *ngIf="!load">
          <mat-spinner [diameter]="50" [color]="color"></mat-spinner>
        </div>

        <div class="content" *ngIf="load && offers?.length">

          <mat-card *ngFor="let o of offers, let i = index" (click)="openOfferInNewTab(o.offerKey)" [id]="getIdOffer(i)"
            class="offer_start">

            <div class="image-offer-container" appIntersectionObserver (intersecting)="o.isVisible = $event">
              <app-image-offer *ngIf="o.isVisible" [matCard]="true" [offerKey]="o.offerKey"
                [height]="'250px'"></app-image-offer>
            </div>

            <mat-card-content>
              <div class="photo_experience" *ngIf="o?.photoExperience">
                <p>{{o?.photoExperience}}</p>
              </div>
              <div class="infos_sub_img">
                <div class="infos">
                  <div class="icon">
                    <fa-icon [icon]="getFaIcon('faClockSolid')"></fa-icon>
                  </div>
                  {{o?.duration}}
                </div>
                <div class="infos">
                  <div class="icon">
                    <fa-icon [icon]="getFaIcon('faMapMarkedAlt')"></fa-icon>
                  </div>
                  <p>
                    {{o?.practicePlace}}
                  </p>
                </div>
              </div>

              <h4><strong>{{o.offerName}}</strong></h4>

              <div class="tags">
                <ng-container *ngFor="let t of o?.mainTags, let i = index">
                  <div class="tag" [style.background-color]="getValueColorTag(t)">{{t.tagName}} </div>
                </ng-container>
              </div>
            </mat-card-content>

            <div class="btn_action" [id]="getIdOfferAdd(o.offerName)">
              <div class="price">
                <div class="icon">
                  <fa-icon [icon]="getFaIcon('faEuroSign')" appChangeColorTheme attribute="color"></fa-icon>
                </div>
                <span> {{o?.price}} </span>
              </div>

              <!-- <div class="actions_offer">
                                <fa-icon class="faShoppingBasket" [icon]="faShoppingBasket"></fa-icon>
             -->
              <fa-icon [icon]="isInMyWishes(o.offerKey)" [style.color]="getColorOfHeart(o.offerKey)"
                (click)="addOrDeleteToMyWish(o, $event); $event.stopPropagation()" appChangeColorTheme
                attribute="color">
              </fa-icon>
              <!-- </div> -->
            </div>
          </mat-card>
        </div>

        <p class="no_offers" *ngIf="load && !offers?.length">Il n'y a pas d'offre.</p>
      </ngx-simplebar>


    </div>

  </section>


</div>